import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid } from "@mui/material";
import { api, AssetLocation, AssetLocationTypes, IListCustomerItem, RequestStatus } from "../../../logic/api";
import propTypes from "prop-types";
import NotchedCard from "../../../components/cards/NotchedCard/NotchedCard";
import EditableField, { EditableFieldTypes } from "../../../components/editable/EditableField/EditableField";
import EditableGroup, { EditableGroupType } from "../../../components/editable/EditableGroup/EditableGroup";
import { SessionContext } from "../../../utility/useSession";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressView } from "../../../components/notifications/progress/ProgressView";
import { useTranslation } from "react-i18next";

const CarParkEditorDialog: React.FunctionComponent<{
  customerId: number;
  carPark?: AssetLocation | null;
  show: boolean;
  onClose: (didSave: boolean, customer: IListCustomerItem | null) => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  const [carPark, setCarPark] = useState<AssetLocation>(props.carPark || {
    iata: "",
    code: "",
    active: true,
    type: AssetLocationTypes.CarPark,
  } as AssetLocation);

  const saveCarPark = api.hooks.admin.saveCarPark();

  const isLoading =
    saveCarPark.status == RequestStatus.loading;


  useEffect(() => {
    if (props.carPark == null) {
      setCarPark({
        iata: "",
        code: "",
        active: true,
        type: AssetLocationTypes.CarPark,
      } as AssetLocation);
    } else {
      setCarPark(props.carPark);
    }

  }, [props.carPark]);


  return <Dialog
    maxWidth={isLoading == true ? undefined : "sm"}
    fullWidth={isLoading == true ? false : true}
    open={props.show}
    keepMounted
    onClose={() => props.onClose(false, null)}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    {isLoading == false && (
      <DialogTitle id="alert-dialog-slide-title">
        <div style={{ textAlign: "center" }}>
          {t("admin.carpark")}
        </div>
      </DialogTitle>
    )}

    <DialogContent>
      <ErrorDialog err={saveCarPark.err}></ErrorDialog>
      <ProgressView
        showError={false}
        noDelay={true}
        status={saveCarPark.status}
      >
        <div style={{ minHeight: 500 }}>

          <NotchedCard label={t("admin.carpark")}>
            <EditableGroup<AssetLocation>
              id="carPark"
              testId="car-park-editor-group"
              editType={EditableGroupType.alwaysEditing}
              data={carPark}
              onDataChanged={async (data) => {
                setCarPark(data);
                return true;
              }}
            >
              <Grid container>


                <EditableField<AssetLocation, string>
                  inputType={EditableFieldTypes.text}
                  label={t("admin.carparkName")}
                  onProvide={(data) => data.name}
                  onChange={(data, value) => data.name = value}
                />


                <EditableField<AssetLocation, string>
                  inputType={EditableFieldTypes.text}
                  label={t("admin.sitecode")}
                  onProvide={(data) => data.code}
                  onChange={(data, value) => data.code = value}
                />

                <EditableField<AssetLocation, string>
                  inputType={EditableFieldTypes.text}
                  label={t("admin.flightLookupIATA")}
                  onProvide={(data) => data.iata}
                  onChange={(data, value) => data.iata = value}
                />
                <EditableField<AssetLocation, boolean>
                  inputType={EditableFieldTypes.switch}
                  label={t("mobile.active")}
                  onProvide={(data) => data.active}
                  onChange={(data, value) => data.active = value}
                />
              </Grid>
            </EditableGroup>
          </NotchedCard>

        </div>
      </ProgressView>
    </DialogContent>
    {isLoading == false && (
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose(false, null);
          }}
          color="primary"
        >
          {t("general.close")}
        </Button>
        <Button
          onClick={() => {
            saveCarPark.send(session.current.context, {
              customerId: props.customerId,
              carPark
            }, (result) => {
              if (result != null) {
                props.onClose(true, null);
              }
            });
            console.log("x");
          }}
          color="primary"
        >
          {t("general.save")}
        </Button>
      </DialogActions>
    )}

  </Dialog>;
}

CarParkEditorDialog.propTypes = {
  customerId: propTypes.number.isRequired,
  carPark: propTypes.any,
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};

export default CarParkEditorDialog;
